import { useMemo, useState } from 'react'

import { useGetDomains } from 'Features/domainsManagement/api/getDomains'
import { useGetTags } from 'Features/domainsManagement/api/getBzMonitorMode'

export const useDomainsWithSearch = () => {
  const [searchText, setSearchText] = useState<string>('')
  const domainsQuery = useGetDomains()
  const { data: tagsData } = useGetTags()

  const domainsWithBZMonitoringMode = useMemo(() => {
    if (domainsQuery.data && tagsData) {
      return domainsQuery.data.data.domains.map((domain) => {
        const tags = tagsData.find((tag) => tag.searchId === domain.tagId)
        const isBzMonitor =
          tags && tags.monitoringMode.isMonitoring ? tags.monitoringMode.isMonitoring : false
        return { ...domain, isBzMonitor }
      })
    } else {
      return []
    }
  }, [domainsQuery.data, tagsData])

  const domains = useMemo(() => {
    if (searchText.length > 0) {
      return domainsWithBZMonitoringMode.filter((domain) =>
        domain.address.includes(searchText.toLowerCase())
      )
    } else {
      return domainsWithBZMonitoringMode
    }
  }, [domainsWithBZMonitoringMode, searchText])

  const onSearchInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(e.target.value)
  }

  return {
    searchText,
    setSearchText,
    onSearchInputChange,
    domains,
    isLoading: domainsQuery.isLoading || domainsQuery.isFetching,
  }
}
